import { wrapper, createApiClient, Result, ApiError } from "../base";
import ColorPaletteDO = App.Data.ColorPaletteDO;

const basePath = `user/profile`;
const baseClient = createApiClient();

export default class {
    getColorPalettes(): Promise<Result<ColorPaletteDO[], ApiError>> {
        return wrapper(baseClient.get(`${basePath}/color-palettes`));
    }
    getColorPalette(uuid: string): Promise<Result<ColorPaletteDO, ApiError>> {
        return wrapper(baseClient.get(`${basePath}/color-palette/${uuid}`));
    }
    createColorPalette(
        colorPalette: ColorPaletteDO
    ): Promise<Result<ColorPaletteDO, ApiError>> {
        return wrapper(baseClient.post(`${basePath}/color-palette`, colorPalette));
    }
    updateColorPalette(
        colorPalette: ColorPaletteDO
    ): Promise<Result<ColorPaletteDO, ApiError>> {
        return wrapper(
            baseClient.put(
                `${basePath}/color-palette/${colorPalette.uuid}`,
                colorPalette
            )
        );
    }
    deleteColorPalette(uuid: string): Promise<Result<string, ApiError>> {
        return wrapper(baseClient.delete(`${basePath}/color-palette/${uuid}`));
    }
}
